import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {DcPageTypeSectionDto} from "./dc-page-type-section.dto";

export class DcPageContentDto extends DtoDetail {

    public pageDtoId : number;
    public pageDtoName : string;
    public pageDtoImage : string;
    public pageDtoColor : string;
    public pageDtoColorBackground : string;
    public content : string;
    public contentDisplay : string;
    public contentTokens : string;
    public section : DcPageTypeSectionDto;
    public orderPriority : number;
    public sectionDtoName : string;
    public sectionDtoId : number;
}